import CssBaseline from "@mui/material/CssBaseline";
import React from "react";
import { createRoot } from "react-dom/client";
import { initializeLoading } from "./utils/showLoading";
import { setupGlobalErrorHandlers } from "./utils/errorHandler";
import "./utils/patchToast";
import ErrorBoundary from "./components/ErrorBoundary";

import App from "./App";

const finishLoading = initializeLoading();
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

setupGlobalErrorHandlers();

root.render(
    <CssBaseline>
        <ErrorBoundary componentName="App">
            <App />
        </ErrorBoundary>
    </CssBaseline>
);

setTimeout(finishLoading, 1000);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(err => {
      console.warn("Service Worker não pôde ser registrado:", err);
    });
  });
}